"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _styling = require("../../toolkit/styling");

var _class, _class2;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var BannerIndicator = (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(BannerIndicator, _Component);

  var _super = _createSuper(BannerIndicator);

  function BannerIndicator() {
    (0, _classCallCheck2["default"])(this, BannerIndicator);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(BannerIndicator, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          pageCount = _this$props.pageCount,
          currentIndex = _this$props.currentIndex,
          className = _this$props.className,
          style = _this$props.style;

      if (pageCount <= 1) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.root, className, style)
      }, new Array(pageCount).fill(null).map(function (_, idx) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          // eslint-disable-next-line react/no-array-index-key
          key: idx,
          className: (0, _styling.css)(_this.styles.circle),
          style: {
            opacity: currentIndex == idx ? 0.4 : 0.1
          }
        });
      }));
    }
  }, {
    key: "styles",
    get: function get() {
      return _aphrodite.StyleSheet.create({
        root: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        },
        circle: {
          backgroundColor: "black",
          borderRadius: "100%",
          ":not(:last-child)": {
            marginRight: 7
          },
          height: 10,
          width: 10
        }
      });
    }
  }]);
  return BannerIndicator;
}(_react.Component), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

var _default = BannerIndicator;
exports["default"] = _default;